export const FirebaseConfig = {
	"projectId": "apiridder",
	"appId": "1:418766654636:web:c3538dccdeed992088e309",
	"databaseURL": "https://apiridder-default-rtdb.firebaseio.com",
	"storageBucket": "apiridder.firebasestorage.app",
	"apiKey": "AIzaSyAjRRMBJh9TPIIGLtU_dICqFTj7Qlf5-90",
	"authDomain": "apiridder.firebaseapp.com",
	"messagingSenderId": "418766654636",
	"measurementId": "G-1FY4ZBB7KP",
	"projectNumber": "418766654636",
	"version": "2"
};